import $ from "jquery";
import Clipboard from "clipboard/dist/clipboard.min";

$(function () {
  const clipboard = new Clipboard("#shareBtn");

  clipboard.on("success", function (e) {
    let tooltip = document.getElementsByClassName("share-tooltip");
    tooltip[0].innerHTML = "Copied!";

    setTimeout(function () {
      tooltip[0].innerHTML = "Share";
    }, 2000);
  });
});
